import { FC } from 'react';

import { SelectForm, SelectFormProps } from './SelectForm';

type RoleSelectFormProps = Omit<SelectFormProps<string>, 'options'>;

const ROLES: SelectFormProps<string>['options'] = [
  // {
  //   name: 'Owner',
  //   value: 'owner',
  // },
  {
    name: 'Manager',
    value: 'manager',
  },
];

export const RoleSelectForm: FC<RoleSelectFormProps> = (props) => {
  return <SelectForm {...props} options={ROLES} />;
};
